import { module } from 'modujs';
import axios from 'axios';
import Ukiyo from "ukiyojs";

export default class extends module {
    constructor(m) {
        super(m);
        this.target = document.querySelector( this.el.dataset.target );
        this.page = 1;
        this.maxNumPages = parseInt( this.el.dataset.maxNumPages );
        this.text = this.el.textContent;
        this.loadingText = this.el.dataset.loadingText;
        this.destroyInstances = [];

        this.el.addEventListener( 'click', (e) => {
            e.preventDefault();
            this.el.parentNode.classList.add( 'loading' );
            this.el.textContent = this.loadingText;
            this.page++;
            let url = this.el.href.split("?")[0] + 'page/' + this.page + '/' + ( this.el.dataset.params || '');
            axios.get( url  ).then( (response) => {

                const doc = document.createElement("div");
                doc.innerHTML = response.data;
                doc.innerHTML = doc.querySelector(this.el.dataset.target ).innerHTML;
                [...doc.querySelectorAll( '& > div' )].forEach( div => this.target.append( div ) );
                this.destroyInstances.push( new Ukiyo( document.querySelectorAll("[data-parallax]:not(.loaded)"), { scale: 1.2, willChange: true } ) );
                this.call( 'update', this.target, 'app' );
                this.el.parentNode.classList.remove( 'loading' );
                this.el.textContent = this.text;
                this.el.parentNode.classList.toggle( 'hidden', this.page === this.maxNumPages );
                this.call('update', false, 'Scroll');
                this.call('updateLazy', false, 'Scroll');
            });
        });
    }


    init() {}
    destroy(){
        this.destroyInstances.forEach( instance => instance.destroy() );
    }
}
